import { faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { alertMessageState, loadingState } from "src/atom/LoadingState";
import callApi from "src/services/Common/api";
import { downloadPDFFromBase64 } from "src/services/Common/FileUtils";

export default function DownloadAdmitCard() {
  const [loading, setLoading] = useState(false);
  const [metaData, setMetaData] = useState({});
  const enableLoader = useSetRecoilState(loadingState);
  const setAlertMessage = useSetRecoilState(alertMessageState);

  useEffect(() => {
    checkRegistertionDateApiCall();
  }, []);

  const download = async () => {
    var downloadAdmitCard = async () => {
      setLoading(true);
      const responseData = await callApi(
        `/v1/api/admit-cards/download-admit-card`,
        "GET",
        null,
        true,
        setAlertMessage,
      );
      if (responseData.success != false) {
        downloadPDFFromBase64(
          responseData.body.base64,
          responseData.body.fileName,
        );
      } else {
      }
      setLoading(false);
    };
    downloadAdmitCard();
  };

  const checkRegistertionDateApiCall = async () => {
    var getRegisterationMetaData = async () => {
      enableLoader(true);
      const responseData = await callApi(
        `/v1/api/check-expiration-date/2`,
        "GET",
        null,
        true,
        setAlertMessage,
      );
      if (responseData.status == 200) {
        setMetaData(responseData.body);
      }
      enableLoader(false);
    };
    getRegisterationMetaData();
  };

  return (
    <>
      <div className="card mt-3">
        <div
          className="card-header text-white"
          style={{ backgroundColor: "#3C4B64" }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <span className="mr-auto">Download Admit Card</span>
          </div>
        </div>
        <div className="card-body">
          {metaData.showViewButton ? (
            <div className="row">
              <div className="col-sm-12">
                <ol>
                  <li>
                    Candidate should carefully read and follow the instructions
                    printed on the answer sheets / question paper.
                  </li>

                  <li>
                    Entry to the Examination Centre is strictly permissible
                    against the Admit Card only.
                  </li>

                  <li>
                    Your admission to the Subject Knowledge Test is provisional
                    & subject to fulfilment of all the conditions of
                    eligibility. All the candidates are being allowed
                    provisionally, without adjudging their eligibility as per
                    advertisement, at this stage. If, at a later stage you are
                    not found eligible, your candidature will be cancelled
                    without any notice.
                  </li>

                  <li>
                    <span className="fw-bold">
                      Bringing of Mobile Phone, Bluetooth, Tablets, Pager or any
                      other Electronic Device etc. and having Wrist watches, any
                      kind of Jewellery (Nose pin, Bangles, Neckless / Chain,
                      Ring / Ear-ring etc.), Purse, Belt, Water Bottles etc. and
                      articles such as Books, Notes & Loose Sheets etc.
                    </span>{" "}
                    to the Examination Centre is strictly prohibited. Hence,
                    candidates are advised not to bring the above items to the
                    Examination Centre as the safe keeping of the same cannot be
                    assured. The Commission will not be responsible for any loss
                    in this regard.
                  </li>

                  <li>
                    Bio-metric attendance is compulsory for all the candidates.
                    Candidates without Bio-metric attendance will be considered
                    as Absent.
                  </li>

                  <li>
                    The candidates are not permitted to sit on any seat other
                    than the seat allotted to them against their Roll Numbers.
                    Violation would have serious consequences.
                  </li>

                  <li>
                    The candidate must write his / her Roll Number & Name in the
                    space provided for the purpose on the Answer Sheet and the
                    Question paper. The candidate must not write anything on the
                    Question paper / Answer Sheet except where a space has been
                    provided.
                  </li>

                  <li>
                    The entry of the candidates shall start at{" "}
                    <span className="fw-bold">
                      07:30 AM (Morning Session) & 12:30 Noon (Evening Session).
                    </span>{" "}
                    No candidate will be admitted to Examination Centre after{" "}
                    <span className="fw-bold">
                      08:50 AM (Morning Session) & 01:50 PM (Evening Session).
                    </span>{" "}
                    It shall be responsibility of the candidate to reach the
                    Examination Centre well in time.
                  </li>

                  <li>
                    The candidate must abide by any further instructions which
                    may be given to him / her by the Supervisor of the
                    Examination centre. If the candidate fails to do so or
                    indulges in disorderly or improper conduct, he / she will
                    render himself liable to expulsion from the Test or such
                    other punishment as the Commission may deem fit to impose.
                  </li>

                  <li>
                    A bell signal will be given at the beginning, half time & at
                    the end of the Examination.
                  </li>

                  <li>
                    <span className="fw-bold">
                      Silence must be observed in the Examination Hall.
                    </span>
                  </li>

                  <li>
                    <span className="fw-bold">
                      Smoking in the Examination Hall and in the precincts of
                      the Centre is strictly prohibited.
                    </span>
                  </li>

                  <li>
                    <ol
                      className="ms-1"
                      style={{ listStyleType: "lower-alpha" }}
                    >
                      <li>
                        Canvassing in any form will disqualify a candidate.
                      </li>
                      <li>
                        A candidate, who makes accusations or insinuation
                        against rival candidates or the Commission as a whole,
                        Chairman or Member of the Commission or its officials
                        etc. may be disqualified.
                      </li>
                      <li>
                        A candidate who is found knowingly to have furnished any
                        particulars which are false or to have suppressed
                        material information will be disqualified, and if
                        appointed, will be liable for dismissal. He will also be
                        liable for proscription from all Government Service and
                        to criminal prosecution.
                      </li>
                    </ol>
                  </li>

                  <li>
                    <span className="fw-bold">
                      Scribe / Extra Time for PwBD category candidates of
                      Haryana:
                    </span>
                    <ol
                      className="ms-1"
                      style={{ listStyleType: "lower-roman" }}
                    >
                      <li>
                        An extra / compensatory time of @ 20 minutes per hour
                        will be allowed in each paper to the Persons with
                        Benchmark Disabilities (Blind and Low vision or
                        Locomotor Disability), only on production of a Medical
                        Certificate issued by Medical Board constituted by the
                        Chief Medical Officer of the concerned district, and
                        after issuing permission by the Commission in this
                        regard.
                      </li>
                      <li>
                        The PwBD (Blindness and Low vision) candidates who want
                        the help of a scribe to write his/her paper will have to
                        apply to the Commission for the permission of a scribe
                        separately well in time i.e. at least 05 days prior to
                        the commencement of the Examination.
                      </li>
                      <li>
                        The candidate has to make his / her own arrangement of a
                        scribe. Commission will not provide any scribe.
                      </li>
                      <li>
                        The scribe should be a studying-student upto 10+2 and
                        his/her photo & other particulars should be duly
                        verified by the Principal of the Institution in which
                        the student is studying. No online request for a scribe
                        will be accepted by the Commission.
                        <br />
                        <br />
                        The PwBD (Blindness and Low vision) candidates who want
                        only extra time (without the help of a scribe) will have
                        to apply to the Commission for the permission for extra
                        time well in time.
                      </li>
                      <li>
                        PwBD candidates suffering from Locomotor Disability who
                        want extra / compensatory time will have to apply to the
                        Commission for permission. Such candidates will be
                        allowed extra time @ 20 minutes per hour for
                        Examination, on production of medical certificate issued
                        by a Medical Board, clearly stating therein that the
                        candidate's writing ability is severally affected due to
                        his / her disability.
                      </li>
                      <li>
                        It should be noted that no such permission in the above
                        cases will be granted by the Centre Supervisor and
                        without the permission letter of the Commission, no
                        extra time will be given by him to any candidate, in any
                        case.
                      </li>
                    </ol>
                  </li>

                  <li>
                    Bring only blue/black ball point pen to attempt the paper.
                    Use of pencil is strictly prohibited. The candidates have to
                    bring their own blue/black ball point pen.
                  </li>

                  <li>Calculator shall not be allowed during the Test.</li>

                  <li>
                    No candidate will write his/her name and roll number
                    incorrectly or at a place other than prescribed on the
                    answer sheet.
                  </li>

                  <li>
                    The answer sheet of the candidate using unfair means will be
                    confiscated and such candidate will stand disqualified.
                  </li>

                  <li>
                    Any omission or discrepancy in filling Roll No and other
                    particular in the space provided on the Answer Sheet /
                    Question paper will render the answer sheet liable for
                    rejection.
                  </li>

                  <li>
                    No candidate will be permitted to leave the Examination Hall
                    before completion of full time of the paper and till the
                    Answer sheets are collected by the Invigilator.
                  </li>

                  <li>
                    Any indiscipline, misbehavior or disregard to the
                    instructions given would lead to forfeiture of the
                    candidature.
                  </li>

                  <li>
                    In view of the judgments of Hon'ble Delhi High Court in W.P.
                    (C) 7550/2017, W.P.(C) 13086/2018 and review petition
                    402/2019 W.P.(C)10550/2019 and Hon'ble Punjab & Haryana High
                    Court in CWP-PIL-65-2019 the baptized sikh candidates who
                    intend to carry Kara and Kirpan to the examination centre,
                    should reach their exam centre one hour before the reporting
                    time and allow the authorities to screen their kara and
                    kirpan to find out as to whether there is any suspected
                    device, electronic or otherwise, used in the same. They will
                    be allowed to wear and carry a kirpan not exceeding than 9
                    inches (22.86 cms.) in total length and 6 inches (15.24
                    cms.) in blade length. In case it is found that there are
                    suspected devices in the said religious signs, they shall be
                    restrained from carrying the same in the examination centre.
                    It is also made clear that in case such candidates failed to
                    report at the examination centre one hour before the
                    reporting time or failed to cooperate with the staff on duty
                    in screening, they shall not be allowed to take the
                    examination with such kara and kirpan.
                  </li>

                  <li>
                    The married women candidates who are wearing Mangal Sutras
                    will also be allowed to wear them in examination hall. Such
                    women candidates should report to the examinations centre at
                    least 30 minutes before the scheduled time.
                  </li>
                </ol>
              </div>
              <div className="col-md-12">
                <div className="text-center mb-3">
                  <button
                    className="btn btn-success text-white"
                    onClick={download}
                    disabled={loading}
                  >
                    <FontAwesomeIcon
                      icon={loading ? faSpinner : faDownload}
                      className="me-2"
                    />
                    {loading ? "Downloading..." : "Download Admit Card"}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12 text-center">
                <h5 className="text-danger">
                  <strong>
                    Your admit card is unavailable because your application form
                    was not submitted before the deadline.
                  </strong>
                </h5>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
